import { StyleProp, StyleSheet, Text, TextStyle } from "react-native";

type WeHonorWordmarkProps = {
  color?: string;
  size?: "sm" | "md" | "lg";
  style?: StyleProp<TextStyle>;
};

/** The WeHonor logotype: lowercase, quiet, and distinct from display type. */
export function WeHonorWordmark({
  color,
  size = "md",
  style,
}: WeHonorWordmarkProps) {
  return (
    <Text
      accessibilityLabel="wehonor"
      style={[styles.base, styles[size], color ? { color } : null, style]}
    >
      wehonor
    </Text>
  );
}

const styles = StyleSheet.create({
  base: {
    fontFamily: "Manrope_500Medium",
    letterSpacing: 0.1,
  },
  sm: {
    fontSize: 11,
    lineHeight: 16,
  },
  md: {
    fontSize: 16,
    lineHeight: 22,
  },
  lg: {
    fontSize: 22,
    lineHeight: 28,
  },
});
